import { render, staticRenderFns } from "./former-years-list.vue?vue&type=template&id=2293a150&scoped=true&"
import script from "./former-years-list.vue?vue&type=script&lang=js&"
export * from "./former-years-list.vue?vue&type=script&lang=js&"
import style0 from "./former-years-list.vue?vue&type=style&index=0&scpoed=true&lang=css&"
import style1 from "../../statistics/css/companyOchart.css?vue&type=style&index=1&id=2293a150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293a150",
  null
  
)

export default component.exports